import { useScenarioType } from "../ScenarioTypeContext"
import { useCheckList } from "./CheckListContext"

// import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"

import Modal from "../../Modal"

const ChangesModal = ({additions, deletions, isOpen}) => {
    const {saveCheckList} = useScenarioType()
    const {
        data,
        // hier,
        hideModal,
        getType
    } = useCheckList()
    const continueEditing = (event) => {
        event.preventDefault()
        hideModal()
    }

    // const recursivelyExpandChecklistItem = (item) => {
    //     const {index, options, items} = item
    //     const {id, type, label, abbrLabel, phase, subPhase} = data[index]
    //     const newItem = {id, type, label, abbrLabel, phase, subPhase}
    //     if (!!options) {
    //         // console.log(options)
    //         newItem.options = []
    //         options.forEach(op =>{
    //             const {index} = op
    //             const {id, type, label, abbrLabel, phase, subPhase} = data[index]
    //             const newOp = {id, type, label, abbrLabel, phase, subPhase}
    //             newItem.options.push(newOp)
    //         })
    //     } else if (!!items) {
    //         newItem.items = []
    //         items.forEach((it, i) => {
    //             newItem.items.push(recursivelyExpandChecklistItem(it))
    //         })
    //     }
    //     return newItem
    // }

    /*
     * trace the 'hier' tree to create the hierarchical structure used by the app, which
     * will be saved as phaseData (awful name)
    */
    // const traceHier = () => {
    //     const newHier = []
    //     hier.forEach((ph, i) => {
    //         const {index, items, subPhases} = ph
    //         const {id, type, label} = data[index]
    //         const newPh = {id, type, label}
    //         if (!!items) {
    //             newPh.items = []
    //             items.forEach((item, j) => {
    //                 newPh.items.push(recursivelyExpandChecklistItem(item))
    //             })
    //         } else if (!!subPhases) {
    //             newPh.subPhases = []
    //             subPhases.forEach((sp, j) => {
    //                 const {index, items} = sp
    //                 const {id, type, label, phase} = data[index]
    //                 const newSp = {id, type, label, phase, items: []}
    //                 if (!!items) {
    //                     items.forEach(it => {
    //                         newSp.items.push(recursivelyExpandChecklistItem(it))
    //                     })
    //                 }
    //                 newPh.subPhases.push(newSp)
    //             })
    //         }
    //         newHier.push(newPh)
    //     })
    //     // strips out fields whose value is "undefined".  There *must* be a better way
    //     const phaseData = JSON.parse(JSON.stringify(newHier))
    //     return phaseData
    // }

    const doneEditing = async (event) => {
        event.preventDefault()
        // const newHier = traceHier()
        const result = await saveCheckList(data) //newHier)
        if (result) {
            console.log("changes saved successfully")
        } else {
            console.log("an error occured while saving")
        }
        hideModal()
    }

    const renderChangesTable = (label, recs) => {
        if (recs.length === 0) {
            return <div></div>
        }
        return (
            <div className="changed-ids">
                {label} items
                <table>
                    <colgroup>
                        <col span="1" style={{ width: "20%" }} />
                        <col span="1" style={{ width: "40%" }} />
                        <col span="1" style={{ width: "40%" }} />
                    </colgroup>
                    <thead>
                        <tr><th>Type</th><th>ID</th><th>Label</th></tr>
                    </thead>
                    <tbody>
                        {recs.map(item =>
                        <tr key={item.id}>
                            <td>{getType(item)}</td>
                            <td>{item.id}</td>
                            <td>{item.label}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    const renderModificationsTable = (additions, deletions) => {
        if (additions.length === 0 && deletions.length === 0) {
            return (<div></div>)
        } else {
            return (
            <>
            <hr />
            <div className="modifications">
                {renderChangesTable("Added", additions)}
                {renderChangesTable("Deleted", deletions)}
            </div>
            </>
            )
        }
    }

    return (
        <Modal
            title="Save Changes"
            isOpen={isOpen}
            close={hideModal}
            closeButton={false}
        >
            <p>
                <b>Warning:</b> your additions and deletions to the checklist are being tracked.
                Saving to the database will reset the tracking of additions and deletions.
            </p>
            <p>
                If you wish to make <b>more changes</b>, click on the "Continue editing" button
            </p>
            <div>
                If you're <b>done editing</b>:
                <ul>
                    <li>copy the list of additions and deletions</li>
                    <li>paste into an email</li>
                    <li>send it to the appropriate people</li>
                    <li>click on the "I'm done" button</li>
                </ul>
            </div>
            {renderModificationsTable(additions, deletions)}
            <button
                type="button"
                onClick={continueEditing}
            >
                Continue editing
            </button>
            <button
                type="button"
                onClick={doneEditing}
            >
                I'm Done
            </button>
        </Modal>
    )

}

export default ChangesModal